export function lodashCustomCompare(value1: any, value2: any): boolean {
  if (!value1 && !value2) {
    return true;
  }

  // Let lodash handle the rest of the comparisons
  return undefined;
}
